import { hasTermWithSlug } from 'util/terms';
import {
  AFFILIATE_SLUG,
  HIDE_ADS_SLUG,
  HIDE_IN_POST_ADS_SLUG,
  HIDE_COMMENTS_SLUG,
  NO_INDEX_SLUG,
  SPONSORED_SLUG
} from 'constants/tags';
import {
  HAS_ACCOUNT,
  HAS_ADS,
  HAS_COMMENTS,
  HIDE_PRISM_TAGS
} from 'constants/site';

// value is from page bundler JSON which, in turn, gets it from WP API.
// ex: https://gen-pagebundler-dot-gen-prod.appspot.com/api/v1/page?site_key=k&path=/zucchini-squash-recipes-260263
// see .contentBundles[0].data.status field
export const PUBLISHED_STATUS = 'publish';

// purposely not checking for 'draft' because of the various WP statuses.
// anything other than 'publish' is considered draft.
export const isDraft = status => status !== PUBLISHED_STATUS;

export const isPublished = status => status === PUBLISHED_STATUS;

export const addCustomPostProps = (props = { data: {} }) => {
  const { status, tags } = props.data || {};
  const hasTag = hasTermWithSlug.bind(null, tags);
  const isSponsored = hasTag(SPONSORED_SLUG);

  return {
    ...props,
    hideAds: HAS_ADS === false || hasTag(HIDE_ADS_SLUG),
    hideInPostAds: hasTag(HIDE_IN_POST_ADS_SLUG),
    hideComments: HAS_COMMENTS === false || hasTag(HIDE_COMMENTS_SLUG),
    hideAccountActions: HAS_ACCOUNT === false,

    // see https://app.asana.com/0/1124493020140997/1126510884858058/f
    hidePrism: [...HIDE_PRISM_TAGS, SPONSORED_SLUG].reduce(
      (acc, curr) => acc || hasTag(curr),
      false
    ),

    isAffiliate: hasTag(AFFILIATE_SLUG),
    isDraft: isDraft(status),
    isNoIndex: hasTag(NO_INDEX_SLUG),
    isSponsored
  };
};
